export const RetryActionPopupTestIds = {
  TRY_AGAIN_BUTTON: 'retry-action-popup.try-again-button',
};
